// TopPaymentsGraph.jsx
import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Box, Typography } from "@mui/material";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";
ChartJS.register(ArcElement, Tooltip, Legend);

export default function TopPaymentsGraph({ data }) {
  if (!data || data.length === 0) {
    return (
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <Typography>No hay datos para analizar</Typography>
      </Box>
    );
  }

  console.log(data)
  const labels = data.map(item => Object.keys(item)[0]);
  const values = data.map(item => Object.values(item)[0]);

  const chartData = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: [
          "#6ce5e8", 
          "#41b8d5",
          "#2d8bba",
          "#506e9a",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `${context.label}: ${context.formattedValue}%`;
          }
        }
      }
    },
  };

  return (
    <Box sx={{ width: "16%", height: "80%"}} >
      <Typography variant="body1" mb={1} textAlign="center">
        Pagos principales
      </Typography>
      <Doughnut data={chartData} options={options} />
    </Box>
  );
}
